module.exports = __webpack_public_path__ + "static/img/3-1.0848186.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/6/3-1.png
// module id = 265
// module chunks = 0